import { render, staticRenderFns } from "./TableForm18.vue?vue&type=template&id=7914f6c0&scoped=true"
import script from "./TableForm18.vue?vue&type=script&lang=ts"
export * from "./TableForm18.vue?vue&type=script&lang=ts"
import style0 from "./TableForm18.vue?vue&type=style&index=0&id=7914f6c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7914f6c0",
  null
  
)

export default component.exports